/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Move_Line_DownInputs */



/**
* | output |
* | --- |
* | "Shift line forward to the beginning of the next Event" |
*
* @param {Shortcut_Keys_Desc_Move_Line_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_move_line_down = /** @type {((inputs?: Shortcut_Keys_Desc_Move_Line_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Move_Line_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer une ligne vers le debut de l'evenement suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Umschaltlinie wird zum Beginn des nächsten Ereignisses vorgeschoben.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta la riga in avanti all'inizio del prossimo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместите линию вперед к началу следующего события.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazar la línea hacia adelante hasta el comienzo del siguiente evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将线向前移动到下一个事件的开始位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次のイベントの先頭まで行を進める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगली घटना की शुरुआत तक लाइन को आगे बढ़ाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desloque a linha para a frente até o início do próximo evento.")
	return /** @type {LocalizedString} */ ("Shift line forward to the beginning of the next Event")
});